export default "__VITE_ASSET__B7Tmy2y6__"